export default __webpack_public_path__ + "static/media/portfolio-hover-195.01d42792.jpg";